/* EDMT product demos: eager native YouTube controls, no custom play overlay. */
(() => {
  'use strict';
  if (window.EDMTYouTubeDemos) {
    window.EDMTYouTubeDemos.mount();
    return;
  }
  const players = new Map();
  const backgroundSelector = '[data-edmt-background], [data-brx-loop], [data-bwh-background-video]';
  let apiPromise;

  function loadAPI() {
    if (window.YT && typeof window.YT.Player === 'function') return Promise.resolve();
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const previousReady = window.onYouTubeIframeAPIReady;
      let timer;
      const check = () => {
        if (!window.YT || typeof window.YT.Player !== 'function') return false;
        clearInterval(timer);
        resolve();
        return true;
      };
      window.onYouTubeIframeAPIReady = function () {
        try {
          if (typeof previousReady === 'function') previousReady.apply(this, arguments);
        } finally {
          check();
        }
      };
      // A bounded fallback also tolerates another theme component replacing the callback.
      const deadline = Date.now() + 30000;
      timer = setInterval(() => {
        if (check()) return;
        if (Date.now() >= deadline) {
          clearInterval(timer);
          reject(new Error('YouTube playback coordination unavailable'));
        }
      }, 100);
      if (!document.querySelector('script[src*="youtube.com/iframe_api"], script[src*="youtube.com/player_api"]')) {
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        script.async = true;
        document.head.appendChild(script);
      }
    });
    return apiPromise;
  }

  function pausePlayers(except) {
    players.forEach(player => {
      if (player !== except && typeof player.pauseVideo === 'function') player.pauseVideo();
    });
  }

  function mount() {
    const frames = [...document.querySelectorAll('iframe[data-edmt-youtube-demo]')];
    if (!frames.length) return;
    // Frames already have src + loading=eager in server-rendered HTML. This API
    // only coordinates audio; its availability never gates native play controls.
    loadAPI().then(() => {
      frames.forEach(frame => {
        if (!frame.isConnected || players.has(frame)) return;
        const player = new window.YT.Player(frame.id, {
          events: {
            onStateChange(event) {
              if (event.data !== window.YT.PlayerState.PLAYING) return;
              document.dispatchEvent(new CustomEvent('edmt:demo-play'));
              document.querySelectorAll('audio, video').forEach(media => {
                if (!media.matches(backgroundSelector)) media.pause();
              });
              pausePlayers(event.target);
            }
          }
        });
        players.set(frame, player);
      });
    }).catch(() => { /* The native embedded player remains usable without the API. */ });
  }

  document.addEventListener('play', event => {
    if (event.target instanceof HTMLMediaElement && !event.target.matches(backgroundSelector)) pausePlayers();
  }, true);
  document.addEventListener('edmt:sample-play', () => pausePlayers());
  document.addEventListener('shopify:section:load', mount);
  document.addEventListener('shopify:section:unload', () => {
    players.forEach((player, frame) => {
      if (!frame.isConnected) {
        player.destroy();
        players.delete(frame);
      }
    });
  });
  window.EDMTYouTubeDemos = { mount };
  mount();
})();
